import { render, staticRenderFns } from "./EditQuery.vue?vue&type=template&id=28b4618f&scoped=true"
import script from "./EditQuery.vue?vue&type=script&lang=js"
export * from "./EditQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b4618f",
  null
  
)

export default component.exports